import React, { createContext, useContext, useEffect, useState } from 'react'
import { useErrorHandling } from 'context/errorHandling'
import { getCustomFieldsByModule } from 'services/CustomFieldService'
import { groupBy } from 'lodash'

const CustomFieldsContext = createContext({
  customFields: [],
  entityId: null
})

export function CustomFieldsProvider ({ module, entityId, children }) {
  const [customFields, setCustomFields] = useState(null)

  const { handleError } = useErrorHandling()

  useEffect(() => {
      getCustomFieldsByModule(module.value)
        .then(fields => groupBy(fields, 'section'))
        .then(setCustomFields)
        .catch(handleError)
    }, [module, handleError]
  )

  const value = {
    customFields,
    entityId
  }

  return (
    <CustomFieldsContext.Provider value={value}>
      {children}
    </CustomFieldsContext.Provider>
  )
}

export function useCustomFields () {
  const { customFields, entityId } = useContext(CustomFieldsContext)
  return { customFields, entityId }
}
